(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("es6-promise"), require("cookie-utils"), require("thd-event-emitter"));
	else if(typeof define === 'function' && define.amd)
		define(["es6-promise", "cookie-utils", "thd-event-emitter"], factory);
	else if(typeof exports === 'object')
		exports["THD_LOCALIZER"] = factory(require("es6-promise"), require("cookie-utils"), require("thd-event-emitter"));
	else
		root["THD_LOCALIZER"] = factory(root["es6-promise"], root["cookie-utils"], root["thd-event-emitter"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_9__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition